import { Form } from 'formik'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StQuestionnaireContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-x: hidden;
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  @media ${breakpoints.s} {
    justify-content: flex-start;
    margin-top: ${({ theme }) => theme.UI.SpacingPx.Space10};
  }
`

const StForm = styled(Form)`
  display: flex;
  flex-direction: column;
  margin-top: auto; /* This pushes content to bottom */

  @media ${breakpoints.s} {
    margin-top: 0;
  }
`

const StQuestionContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`

const StActionContainer = styled.div`
  flex-grow: 0;
  grid-area: button;
  box-shadow: 0px -1px 20px rgba(4, 24, 49, 0.07);

  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space6};
    padding-bottom: calc(${theme.UI.SpacingPx.Space6} + max(var(--safe-area-inset-bottom), 20px));
  `} @media ${breakpoints.s} {
    box-shadow: none;
    padding: 0 ${({ theme }) => theme.UI.Spacing.Space6 + 50}px;
    margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space15};
    display: flex;
    justify-content: flex-end;
  }

  @media ${breakpoints.m} {
    padding: 0 ${({ theme }) => theme.UI.Spacing.Space6 + 100}px;
  }

  @media ${breakpoints.l} {
    padding: 0 ${({ theme }) => theme.UI.Spacing.Space6 + 220}px;
  }
`

export { StActionContainer, StForm, StQuestionContainer, StQuestionnaireContainer }
